export const LOGO_URL =
  "https://customer-assets-eiarnc6j.emergentagent.net/job_import-project-23/artifacts/9aca4707697d582d_Buscema%20final%20logo.ai%20%281%29%20%281%29.jpg";
